 namespace('arctic.views.common');

/*this tests errors when they happen in the python layer*/
/*you can hit http://localhost:8888/e/350Compass15/0#testBackendErrors to have python throw an error*/
/*it should get back up to the JS side and you should see an oops message and a new error aggregator (bugsnag) item*/
/*the ajax_helpers wrapper is what is responsible for catching any errors happening on the backend and reporting them to the user*/
arctic.views.common.testBackendErrors = function(viewport, data) {

	var testWS = data.testWebServices ? data.testWebServices : false;
    
    this.run = function() {
        jQuery.ajax( {
            url : '/testBackendErrors',
            data: {'testWebServices': testWS},
            dataType: 'json',
            success: function(availData) {
                alert('finished loading testBackendErrors views');
            }
        } );

    };

};

